<template>
  <div id="app" class="sample-order-app-container">
    <progressbar :progressbar="getProgressbar"></progressbar>
      <div class="row">
        <template v-if="currentStep === 1">
          <div class="col col-12 col-lg-9">
            <color-sample-overview 
              :items="items" 
              :action-url="actionURL" 
              :structures="structures"
              @updateCartData="onUpdateCartData" 
              :currency="currency" 
              :can-modify-quantity="canModifyQuantity" 
            />
            <color-sample-shades v-if="shades.length>0 && items.length==1" 
              :shades="shades" 
              @updateCartData="onUpdateCartData" 
            />
            <color-sample-combinations v-if="combinations.length>0 && items.length==1" 
              :combinations="combinations" 
              @updateCartData="onUpdateCartData" 
            />
         </div>
          <div class="col col-12 col-lg-3">
            <color-sample-side-bar
                :getSubtotal="getSubtotal"
                :getOptionalCost="getOptionalCost"
                :getVat="getVat"
                :getTotal="getTotal"
                :currentStep="currentStep"
                :getCheckoutClasses="getCheckoutClasses()"
                :paymentMethods="paymentMethods"
                :getVatPercent="getVatPercent"
                v-on:back="back"
                v-on:forward="forward"
                v-on:pay="pay"
            ></color-sample-side-bar>
          </div>
        </template>
        <template v-if="currentStep === 2">
          <div class="col-12 col-lg-12">
            <div class="row">
              <div class="col-12">
                <span class="color-order-billing-title">{{ trans('sample_order_step2_title') }}</span>
                <span class="color-order-billing-subtitle pb-3">{{ trans('sample_order_step2_required_info') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-lg-12">
                <color-sample-checkout v-if="currentStep === 2" :forwardclass="getCheckoutClasses()" :showValidate="showValidate" :items="items" @back="back" @forward="forward" @customerData="onCustomerDataChanged" :currency="currency"/>
              </div>
            </div>
          </div>
        </template>
        <template v-if="currentStep === 3">
          <div class="col col-12 col-lg-9">
            <color-sample-payment v-if="currentStep === 3" :items="items" @back="back" :currency="currency" :customer-data="customerData"/>
          </div>
          <div class="col col-12 col-lg-3">
            <color-sample-side-bar
                :getSubtotal="getSubtotal"
                :getOptionalCost="getOptionalCost"
                :getVat="getVat"
                :getTotal="getTotal"
                :currentStep="currentStep"
                :getCheckoutClasses="getCheckoutClasses()"
                :paymentMethods="paymentMethods"
                :getVatPercent="getVatPercent"
                v-on:back="back"
                v-on:forward="forward"
                v-on:pay="pay"
            ></color-sample-side-bar>
          </div>
        </template>
      </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import ColorSampleOverview from "./components/ColorSampleOverview";
  import ColorSampleCombinations from "./components/ColorSampleCombinations";
  import ColorSampleShades from "./components/ColorSampleShades";
  import ColorSampleCheckout from "./components/ColorSampleCheckout";
  import ColorSamplePayment from "./components/ColorSamplePayment";
  import {translate} from "./service/translation";
  import {priceFormat} from "./service/format";
  import progressbar from "@/components/progressbar/progressbar";
  import ColorSampleSideBar from "@/components/ColorSampleSideBar";

  export default {
    name : 'ColorSampleOrdering',
    components : {
      ColorSampleOverview,
      ColorSampleCheckout,
      ColorSamplePayment,
      ColorSampleCombinations,
      ColorSampleShades,
      ColorSampleSideBar,
      progressbar
    },
    created() {
      this.structures = window.availableStructures;
      this.actionURL = '/sample-order/cart';
      this.getItemsURL = '/sample-order/getCartItems';
      this.currency = window.sampleOrderCurrency;
      this.paymentMethods = [
        {
          icon : 'credit-card',
          name : this.trans('sample_order_bank_card'),
          extraIcons: [
            'cc-visa',
            'cc-mastercard',
            'cc-amex'
          ]
        }
      ]
      this.getItems();
      let self = this;
       window.$('body').on('updateSampleCartData',function(e,data){
         self.onUpdateCartData(data.cartData);
         //self.items = data.cartData;
       });
    },
    data : function() {
      return {
        paymentMethods : [],
        currency : '',
        currentStep : 1,
        items : [],
        combinations : [],
        shades : [],
        actionURL : '',
        total : 0,
        optionalCost : 0,
        structures : [],
        customerData : null,
        paying : false,
        canModifyQuantity : true,
        showValidate : false,
        progressbar:{
          'step0': 'active',
          'step1': '',
          'step2': '',
          'step3': ''
        }
      }
    },
    mounted() {
      this.canModifyQuantity = !location.host.includes('baumit.si')
    },
    methods : {
      onCustomerDataChanged(data) {
        this.customerData = data;
      },
      doValidate(){
        this.showValidate = true
      },
      canGoForward() {
        let valid = false;
        switch(this.currentStep) {
          case 1 :
              return this.items.length > 0;
          case 2 :
              return this.customerData !== null;
          case 3 :
              return !this.paying;
          default:
            valid = true;
            break;
        }
        return valid;
      },
      getCheckoutClasses() {
        if ( this.canGoForward() ) {
          return 'color-sample-checkout-active';
        }
        return '';
      },
      forward() {
        this.doValidate()
        if ( !this.canGoForward()) {
          return;
        }
        if ( this.currentStep === 2 ) {
          axios
              .post(this.actionURL, {
                action : 'saveCustomerData',
                data : this.customerData
              });
        }
        ++this.currentStep;
        this.outercontentFix();
      },
      pay() {
        this.paying = true;
        axios.post('/sample-order/startOrder', {
          data : this.customerData
        }).then(function(response){
            if ( response.data.success ) {
              window.location.href= response.data.redirectUrl;
            }
        });
      },
      back() {
        if ( this.currentStep < 1 ) {
          return;
        }
        -- this.currentStep;
        this.outercontentFix();
      },
      outercontentFix(){
        if(this.currentStep==1){
          window.$('.sample-order-custompage-page-content').show();
          window.$('.sample-order-color-picker').show();
        }
        else{
          window.$('.sample-order-custompage-page-content').hide();
          window.$('.sample-order-color-picker').hide();
        }
      },
      updateCombinations(){
        if(this.items.length==1){
          this.getColorCombinations(this.items[0].color.id);
        }
      },
      updateShades(){
        if(this.items.length==1){
          this.getColorShades(this.items[0].color.id);
        }
      },
      getItems(){
        let self = this;
        axios.get(this.getItemsURL).then(function(resp){
          self.items = resp.data.cartData;
          self.updateCombinations();
          self.updateShades();
        });
      },
      getColorCombinations(colorid){
        let self = this;
        axios.get('/baumitlife/getColorCombinations/'+colorid).then(function(resp){
          self.combinations = resp.data.combinations;
        });
      },
      getColorShades(colorid){
        let self = this;
        axios.get('/baumitlife/getColorShades/'+colorid).then(function(resp){
          self.shades = resp.data.shades;
        });
      },
      onUpdateCartData(cartData){
        console.log('updatecartData',cartData);
        this.items = cartData;
        this.updateCombinations();
        this.updateShades();
        if(typeof window.updateSampleCartCount == "function"){
          window.updateSampleCartCount(cartData)
        }
      },
      calculateSubtotal() {
          let subtotal = 0;
          let item = null;
          for (let index in this.items) {
            item = this.items[index];
            subtotal += (item.unit_price * item.qty);
          }
          return subtotal;
      },
      trans(key){
        return translate(key);
      },
    },
    computed : {
      getSubtotal: function () {
        return this.currency + ' ' + priceFormat(this.calculateSubtotal(), window.sampleOrderShowPriceDecimals);
      },
      getOptionalCost: function () {
        return this.currency + ' ' + priceFormat(this.optionalCost, window.sampleOrderShowPriceDecimals);
      },
      getVatValue: function () {
        let vat = typeof window.sampleOrderVat != 'undefined' ? window.sampleOrderVat : 0;
        let vatPrice = 0;
        this.items.forEach(function(item){
          let itemVat = item.unit_price / 100 * vat;
          itemVat = Math.round((itemVat + Number.EPSILON) * 100) / 100;
          vatPrice+= itemVat*item.qty;
        });
        console.log(vatPrice);
        return vatPrice;
      },
      getVatPercent: function () {
        return (typeof window.sampleOrderVat != 'undefined' ? window.sampleOrderVat : 0)+'%';
      },
      getTotalValueWithoutVat: function(){
        return this.calculateSubtotal() + this.optionalCost;
      },
      getTotalValueWithVat: function(){
        return this.calculateSubtotal() + this.optionalCost + this.getVatValue;
      },
      getVat: function(){
        return this.currency + ' ' + priceFormat(this.getVatValue, window.sampleOrderShowPriceDecimals);
      },
      getTotal: function () {
        return this.currency + ' ' + priceFormat(this.getTotalValueWithVat,window.sampleOrderShowPriceDecimals);
      },
      getProgressbar: function (){
        if(this.currentStep ==1){
          return {
            'step0': 'active',
            'step1': '',
            'step2': '',
            'step3': ''
          }
        }else if(this.currentStep ==2){
          return {
            'step0': 'passed',
            'step1': 'active',
            'step2': '',
            'step3': ''
          }
        }else if(this.currentStep ==3){
          return {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'active',
            'step3': ''
          }
        }else{
          return {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'passed',
            'step3': 'active'
          }
        }
      }
    }
  }
</script>
<style lang="less">
.color-sample-checkout-title {
  font-family: "FranklinGothicDemiITC";
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  color: #000000;
}
.color-order-checkout-container {
  padding: 15px 0px;
}
#color-order-checkout {
  width: 100%;
  display: block;
  background: #E4E4E4;
  color: white;
  text-align: center;
  padding: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}
#color-order-checkout-v2.type-2 {
  &:not(.color-sample-checkout-active) {
    background: #E4E4E4 !important;
  }
}
.color-sample-checkout-active {
  &:not(.type-2) {
    cursor: pointer;
    background: #DF0A25 !important;
  }
}
h3 {
  font-family: "FranklinGothicBookITC";
  font-size: 62px;
  font-style: normal;
  font-weight: 400;
  line-height: 70px;
  letter-spacing: 0em;
  text-align: left;
}
#color-sample-cost {
  .cell {
    font-family: "FranklinGothicBookITC";
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    letter-spacing: 0em;
    text-align: left;
    &:last-child {
      text-align: right;
    }
  }
  .color-sample-cost-row {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    width: 100%;
    &:first-child {
      border-bottom: 2px solid #E3E3E3;
    }
    &:nth-child(2) {
      border-bottom: 2px solid #E3E3E3;
    }
  }
}
.color-sample-payment-methods {
  background: rgba(196, 196, 196, 0.25);
  padding: 10px 20px 10px 20px;
  margin-bottom: 10px;
}
.color-sample-payment-icon {
  float: left;
  margin-right: 10px;
}
@media only screen and (min-width: 940px) {
  .color-sample-sidebar {
    padding-left: 20px !important;
  }
  .color-sample-items {
    padding-top: 20px !important;
  }
}

</style>